(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/scroll-top/assets/scroll-top-on-nav.js') >= 0) return;  svs.modules.push('/components/lb-ui/scroll-top/assets/scroll-top-on-nav.js');
'use strict';

const {
  useState
} = React;
const {
  useLocation
} = ReactRouterDOM;

const ScrollTopOnNav = _ref => {
  let {
    children
  } = _ref;
  const [path, setPath] = useState();
  const location = useLocation();
  const scrollTop = () => {
    window.scrollTo(0, 0);
  };
  React.useEffect(() => {
    if (location.pathname !== path) {
      scrollTop();
      setPath(location.pathname);
    }
  }, [location, path]);
  return children;
};
svs.tb_ui_react.scrollTop.ScrollTopOnNav = ScrollTopOnNav;

 })(window);